<template>
    <v-layout row wrap>
        <failure-snackbar v-model="error">{{errorMsg}}</failure-snackbar>
        <v-flex xs12 lg10 xl8 offset-lg1 offset-xl2>
            <additional-info :event="event"></additional-info>
        </v-flex>
        <v-flex xs12 lg10 xl8 offset-lg1 offset-xl2>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card>
                        <v-card-title class="subheading">
                            <v-layout justify-center align-center>
                                <v-flex shrink mr-2 hidden-sm-and-down>
                                    <v-img :src="logo" width="150"></v-img>
                                </v-flex>
                                <v-flex>
                                    <v-layout column>
                                        <v-flex tag="strong">
                                            {{event.name}}
                                        </v-flex>
                                        <v-flex mt-1 class="caption">
                                            <v-layout wrap>
                                                <v-flex shrink>
                                                    <v-layout column>
                                                        <v-flex py-0>
                                                            <strong>Zeitraum:</strong> {{_.get(event, 'date_range')}}
                                                        </v-flex>
                                                        <v-flex py-0 v-if="!_.get(event, 'online')">
                                                            <strong>Veranstaltungsort:</strong> {{_.get(location,
                                                            'name')}}
                                                        </v-flex>
                                                        <v-flex py-0 v-else>
                                                            <a :href="_.get(event, 'url')">{{ _.get(event, 'url') }}</a>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex v-if="!_.get(event, 'online')">
                                                    <v-layout column>
                                                        <v-flex py-0>
                                                            <strong>Straße:</strong> {{_.get(location, 'street') + ' ' +
                                                            _.get(location, 'street_suffix')}}
                                                        </v-flex>
                                                        <v-flex py-0>
                                                            <strong>Ort:</strong> {{_.get(location, 'postcode') + ' ' +
                                                            _.get(location, 'city')}}
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <!--                <v-flex d-flex lg3>-->
                <!--                    <event-box :event="event" :location="location"></event-box>-->
                <!--                </v-flex>-->
                <v-flex xs12 md8 lg8 order-xs2 order-md1>
                    <s-stepper></s-stepper>
                </v-flex>
                <v-flex xs12 md4 lg4 order-xs1 order-md2>
                    <price-box></price-box>
                    <multi-ticket-info-box v-if="event.group_sale && event.discount_active" class="mt-2"></multi-ticket-info-box>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'

    export default {
        name: "Checkout",
        props: {
            logo: String,
            event: [Object, Array],
            organizer: [Object, Array],
            tickets: [Object, Array],
            countries: Array,
            states: Object,
            location: Object,
        },
        computed: {
            ...mapState('form', [
               'attendees',
                'errorMsg',
            ]),
            error: {
                get() {
                    return this.$store.state.form.error;
                },
                set(v) {
                    this.$store.commit('form/setError', v);
                }
            },
        },
        created: function () {
            this.$store.registerModule('stepper', {
                namespaced: true,
                state: {
                    step: 1,
                    loading: false
                },
                mutations: {
                    setStep(state, payload) {
                        state.step = payload;
                    },
                    previousStep(state) {
                        state.step--;
                    },
                    nextStep(state) {
                        state.step++;
                    },
                    setLoading(state, payload) {
                        state.loading = payload;
                    }
                }
            });
            this.$store.registerModule('form', {
                namespaced: true,
                state: {
                    event: this.event,
                    organizer: this.organizer,
                    countries: this.countries,
                    states: this.states,
                    error: false,
                    errorMsg: false,
                    ticketsLoading: false,
                    submitting: false,
                    tickets: [{}],
                    attendees: {},
                    invoiceRecipient: {},
                    paymentType: '',
                    coupon: null,
                    isFree: true,
                    priceDetails: {},
                },
                mutations: {
                    setError(state, error) {
                        state.error = error;
                    },
                    setErrorMsg(state, msg) {
                        state.errorMsg = msg;
                    },
                    setTicketsLoading(state, loading) {
                        state.ticketsLoading = loading;
                    },
                    setSubmitting(state, submitting) {
                        state.submitting = submitting;
                    },
                    setTickets(state, payload) {
                        state.tickets = payload.slice();
                    },
                    addAttendee(state, ticketId) {
                        let attendee = {country_code: 'DE', state_code:null, partner_amboss:false, partner_amboss_campus:false, partner_apobank:false, partner_allianz:false, formResultFields:{}};
                        state.event.form_fields.forEach((formField)=>{
                            attendee.formResultFields[formField.id] = {form_field_id: formField.id, value: null}
                        })
                        state.attendees[ticketId].push(attendee);
                    },
                    removeAttendee(state, ticketId) {
                        state.attendees[ticketId].pop();
                    },
                    setInvoiceRecipient(state, payload) {
                        state.invoiceRecipient = payload;
                    },
                    setPaymentType(state, payload) {
                        state.paymentType = payload;
                    },
                    setCoupon(state, payload) {
                        state.coupon = payload;
                    },
                    setIsFree(state, payload) {
                        state.isFree = payload;
                    },
                    setPriceDetails(state, priceDetails){
                        state.priceDetails = priceDetails;
                    }
                },
                actions: {
                    setError({commit, state}, msg){
                        commit('setError', true);
                        commit('setErrorMsg', msg);
                    },
                    setTickets({dispatch, commit, state}, tickets) {
                        commit('setTickets', tickets);
                        _.forEach(tickets, function (ticket) {
                            let attendees = state.attendees[ticket.id];
                            let numberOfAttendees = attendees.length;
                            let quantity = ticket.quantity;
                            if (numberOfAttendees < quantity) {
                                for (; numberOfAttendees < quantity; numberOfAttendees++) {
                                    commit('addAttendee', ticket.id);
                                }
                            } else if (quantity < numberOfAttendees) {
                                for (; quantity < numberOfAttendees; quantity++) {
                                    commit('removeAttendee', ticket.id);
                                }
                            }
                        });
                        dispatch('calculatePrice');
                    },
                    calculatePrice({commit, state, dispatch}) {
                        commit('setTicketsLoading', true);
                        let url = '/checkout/prices';
                        axios.post(url, {tickets: state.tickets, coupon: state.coupon, event: state.event}, {}).then((response) => {
                            commit('setPriceDetails', response.data.priceDetails);
                            commit('setIsFree', response.data.isFree);
                            if (response.data.couponError) {
                                commit('setCoupon', null);
                                dispatch('setError', response.data.couponError);
                            }
                            commit('setTicketsLoading', false);
                        }).catch(() => {
                            commit('setPriceDetails', {
                                discount: false,
                                items: [],
                                taxRate: "",
                                totalBrutto: "",
                                totalNetto: "",
                                totalTax: "",
                            });
                            commit('setTicketsLoading', false);
                        });
                    },
                    applyCoupon({dispatch, commit, state}, coupon) {
                        commit('setCoupon', coupon);
                        dispatch('calculatePrice');
                    },
                    fillData({commit, state}, payload) {
                        if (payload) {
                            commit('setInvoiceRecipient', state.attendees);
                        } else {
                            commit('setInvoiceRecipient', {});
                        }
                    }
                },
            });
            this.$store.commit('form/setTickets', this.tickets);
            _.forEach(this.tickets, (ticket) => {
                Vue.set(this.attendees, ticket.id, []);
                Vue.set(ticket, 'quantity', 0);
            });
        },
    }
</script>

<style scoped>

    .data-row-title {
        display: inline-block;
        width: 60px;
    }
</style>
